module.exports = __webpack_public_path__ + "img/trip(3).99f7826a.webp";